import { MapMarker, CustomOverlayMap } from 'react-kakao-maps-sdk'
import styled from 'styled-components'
import { CouponMapProps } from 'src/pages/CouponMapPage'
import current_marker_icon from 'src/assets/images/map/current_marker.png'
import React from 'react'
import selected_store_marker from 'src/assets/images/map/store_icon/active_store_marker.png'
import RenderIf from 'src/components/common/RenderIf'
import { Typography } from 'src/components/common/Typography'
import { Noto_body3_m12 } from 'src/styles/fonts/NotoSansKrFonts'
import marker_bread_icon from 'src/assets/images/map/store_icon/map_category_bread_icon.png'
import marker_life_icon from 'src/assets/images/map/store_icon/map_category_life_icon.png'
import marker_chicken_icon from 'src/assets/images/map/store_icon/map_category_chicken_icon.png'
import marker_coffee_icon from 'src/assets/images/map/store_icon/map_category_coffee_icon.png'
import marker_burger_icon from 'src/assets/images/map/store_icon/map_category_burger_icon.png'
import marker_convenient_icon from 'src/assets/images/map/store_icon/map_category_convenient_icon.png'
import marker_restaurant_icon from 'src/assets/images/map/store_icon/map_category_restaurant_icon.png'

const categoryByMarkerImg = [
  //기존 사용중 넘버
  { CategoryNumber: 1, CategoryName: '베이커리', CategoryImg: marker_bread_icon },
  { CategoryNumber: 2, CategoryName: '피자/버거/분식', CategoryImg: marker_burger_icon },
  { CategoryNumber: 4, CategoryName: '생활', CategoryImg: marker_life_icon },
  { CategoryNumber: 7, CategoryName: '외식', CategoryImg: marker_restaurant_icon },
  { CategoryNumber: 8, CategoryName: '치킨', CategoryImg: marker_chicken_icon },
  { CategoryNumber: 9, CategoryName: '카페/디저트', CategoryImg: marker_coffee_icon },
  { CategoryNumber: 10, CategoryName: '편의점', CategoryImg: marker_convenient_icon },
  //쿠폰사 교체로 인한 추가 넘버
  { CategoryNumber: 101, CategoryName: '베이커리', CategoryImg: marker_bread_icon },
  { CategoryNumber: 102, CategoryName: '피자/버거/분식', CategoryImg: marker_burger_icon },
  { CategoryNumber: 104, CategoryName: '생활', CategoryImg: marker_life_icon },
  { CategoryNumber: 107, CategoryName: '외식', CategoryImg: marker_restaurant_icon },
  { CategoryNumber: 108, CategoryName: '치킨', CategoryImg: marker_chicken_icon },
  { CategoryNumber: 109, CategoryName: '카페/디저트', CategoryImg: marker_coffee_icon },
  { CategoryNumber: 110, CategoryName: '편의점', CategoryImg: marker_convenient_icon },
]

const CurrentPositionMarker = ({ userLocation }: Pick<CouponMapProps, 'userLocation'>) => {
  return (
    <RenderIf when={!!userLocation}>
      <MapMarker
        position={userLocation!}
        image={{ src: current_marker_icon, size: { width: 30, height: 30 } }}
      />
    </RenderIf>
  )
}

const StoreMarker = ({
  storeMarkers,
  handleUpdateActiveStoreCard,
  selectedStore,
  filterBrand,
}: CouponMapProps) => {
  const filterStoreMarker = !filterBrand
    ? storeMarkers
    : storeMarkers?.filter((w) => w.brandNumber === filterBrand?.brandNumber)

  return (
    <React.Fragment>
      {filterStoreMarker?.map((storeInfo, index: number) => {
        const { position, categoryNumber, place_name } = storeInfo
        const selectedMarker = selectedStore?.place_name === storeInfo.place_name
        const defaultMarkerImg =
          categoryByMarkerImg.find((w) => w.CategoryNumber === categoryNumber)?.CategoryImg || ''

        const storeMarker = selectedMarker
          ? { src: selected_store_marker, size: { width: 40, height: 50 } }
          : { src: defaultMarkerImg, size: { width: 28, height: 28 } }

        return (
          <React.Fragment key={index}>
            <MapMarker
              position={position}
              onClick={() => handleUpdateActiveStoreCard.set({ ...storeInfo })}
              image={storeMarker}
              zIndex={selectedMarker ? 2 : 1}
            />
            <CustomOverlayMap position={position} zIndex={selectedMarker ? 1 : 0}>
              <S.MarkerPlaceName $fontStyle={Noto_body3_m12}>{place_name}</S.MarkerPlaceName>
            </CustomOverlayMap>
          </React.Fragment>
        )
      })}
    </React.Fragment>
  )
}

const S = {
  MarkerPlaceName: styled(Typography)`
    position: relative;
    top: 9px;
    border-radius: 4px;
    background-color: var(--white);
    padding: 0 2px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  `,
}
export const Marker = {
  Current: CurrentPositionMarker,
  Store: StoreMarker,
}
